import {useEffect, useState} from "react";
import {SocketApi} from "../api/socket-api";
const generateInitialPoints = (numPoints: number, start:number = 0) => {
    const points = [];
    for (let i = start; i < numPoints+start; i++) {
        const x = i * 10; // шаг по оси x
        const y = Math.sin(i * 0.1) * 50 + 100; // пример синусоидальной функции для оси y
        points.push({ x, y });
    }
    return points;
};
export const UseConnectSocket = (reportId: string) => {
    const [data, setData] = useState<any>([]);

    // Функция для подключения к сокету и присоединения к комнате
    const connectSocket = () => {
        // Устанавливаем соединение с сокетом
        SocketApi.createConnection();

        // Присоединяемся к комнате с reportId
        if (SocketApi.socket) {
            SocketApi.socket.emit('joinReportRoom', reportId);
        }

        // Обработка сообщений от сервера
        SocketApi.socket?.on('server-message', (dto) => {
            console.log(dto, 'dto'); // Логирование данных
            setData(dto); // Обновление состояния
        });
    };

    // Функция для отключения от комнаты
    const disconnectFromRoom = () => {
        if (SocketApi.socket) {
            SocketApi.socket.emit('leaveReportRoom', reportId);
        }
    };

    useEffect(() => {
        connectSocket(); // Подключаемся к сокету и присоединяемся к комнате

        // Очистка при размонтировании компонента
        return () => {
            disconnectFromRoom(); // Отключаемся от комнаты
            SocketApi.socket?.off('server-message'); // Отписываемся от события
        };
    }, [reportId]); // Зависимость от reportId

    return { data };
};
